import { jwtDecode } from "jwt-decode";

import axiosNewApi from "../config/axiosNewApi";
import { setToken } from "../lib/auth";

export const login = async (values) => {
  try {
    const response = await axiosNewApi.post("auth/login", values);

    if (response.status === 200) {
      if (response.data && response.data.data.token) {
        const token = response.data.data.token;
        setToken(token);
        return response.data; // Return the data on successful login
      } else {
        throw new Error("Token not found in the response");
      }
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    throw error;
  }
};
